<!-- header -->
<h2 mat-dialog-title mat-dialog-draggable-title> {{'title.synchronized_customer' | translate}}
    <button type="button" class="close" aria-label="Close" (click)="onBtnCancelClick()">
        <span aria-hidden="true">&times;</span>
    </button>
</h2>
<!-- end header -->
<mat-divider></mat-divider>
<mat-dialog-content>
    <mat-accordion #accordion="matAccordion" [multi]="true">
        <mat-expansion-panel expanded="true" class="mt-3">
            <mat-panel-title class="mat-panel-title mb-2 mt-3 d-flex justify-content-between align-items-center">
                {{ "title.search_condition" | translate }}
            </mat-panel-title>
            <form #f="ngForm" class="pb-3" (ngSubmit)="onFilterCustomers(0, paginate.pageSize)"
                (keydown.enter)="onFilterCustomers(0, paginate.pageSize)">
                <div class="row">
                    <div class="col-8">
                        <mat-form-field class="w-100">
                            <input
                                (focusout)="customer.keyword = customer.keyword == undefined ? '' : (customer.keyword + '').trim()"
                                #focusInput matInput type="text"
                                [placeholder]="'enterprise_customer_management.lbl_searchCustomerSync' | translate"
                                name="keyword" [(ngModel)]="customer.keyword" maxlength="200" autocomplete="off" />
                            <button mat-button *ngIf="customer.keyword" type="button" matSuffix mat-icon-button
                                aria-label="Clear" (click)="customer.keyword=''">
                                <mat-icon>close</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field class="w-100">
                            <mat-select id="syncStatus" name="syncStatus"
                                [placeholder]="'headertable.sync_status' | translate"
                                [(ngModel)]="customer.syncStatus"
                                (ngModelChange)="onFilterCustomers(0, paginate.pageSize)">
                                <mat-option value="">
                                    {{
                                    "system_document_template.cbx_document_status.cbx_document_status_select_all"
                                    | translate
                                    }}
                                </mat-option>
                                <mat-option value="SYNCED">
                                    {{
                                    "system_document_template.cbx_document_status.cbx_document_status_synced"
                                    | translate
                                    }}
                                </mat-option>
                                <mat-option value="NOT_SYNCED">
                                    {{
                                    "system_document_template.cbx_document_status.cbx_document_status_not_synced"
                                    | translate
                                    }}
                                </mat-option>
                            </mat-select>
                            <button mat-button *ngIf="customer.syncStatus" type="button" matSuffix mat-icon-button
                                aria-label="Clear" (click)="customer.syncStatus=''">
                                <mat-icon>close</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-center">
                        <button mat-stroked-button color="primary" type="submit" (click)="onClickBtnFilter()" appTrackEvent="w.btn.danh_sach_kh.dong_bo.tim_kiem">
                            <mat-icon class="mr-0" style="font-weight: 900">search</mat-icon>
                            {{ "search_form.search" | translate }}
                        </button>
                    </div>
                </div>
            </form>

            <mat-panel-title class="mat-panel-title mb-2 mt-3 d-flex justify-content-between align-items-center">
                <span
                    *ngIf="!commonService.getIsLockedEnterprise()">{{'enterprise_customer_management.list_customer_sync'
                    |
                    translate}}
                    ({{paginate.totalRow}}), {{'enterprise_customer_management.selected' | translate}}
                    {{this.dataSelected.size}}
                </span>
                <span
                    *ngIf="commonService.getIsLockedEnterprise()">{{'enterprise_customer_management.list_customer_sync'
                    |
                    translate}}
                    ({{paginate.totalRow}})
                </span>
            </mat-panel-title>

            <div class="mat-table-container">
                <mat-table [dataSource]="dataSource" width="100%">
                    <!-- check-->
                    <ng-container matColumnDef="check">
                        <mat-header-cell *matHeaderCellDef
                            class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom">
                            <mat-checkbox [disabled]="commonService.getIsLockedEnterprise()"
                                *ngIf="dataSource && dataSource.data && dataSource.data.length > 0"
                                [(ngModel)]="checkAll" (change)="checkAllDocument()" color="primary"></mat-checkbox>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element"
                            class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom"
                            (click)="$event.stopPropagation()">
                            <mat-checkbox color="primary" [(ngModel)]="element.checked"
                                (change)="onSelectionChange(element)"
                                [disabled]="commonService.getIsLockedEnterprise()">
                            </mat-checkbox>
                        </mat-cell>
                    </ng-container>
                    <!-- STT -->
                    <ng-container matColumnDef="id">
                        <mat-header-cell *matHeaderCellDef
                            class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                            {{'enterprise_customer_management.table_headers.No' | translate}}</mat-header-cell>
                        <mat-cell *matCellDef="let element"
                            class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                            {{paginate.no[dataSource.filteredData.indexOf(element)]}}</mat-cell>
                    </ng-container>

                    <!-- Mã khách hàng -->
                    <ng-container matColumnDef="code">
                        <mat-header-cell *matHeaderCellDef style="width: 20%;" class="mat-cell-non-boder-right-bottom">
                            {{'enterprise_customer_management.table_headers.customer_code' | translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" matTooltip="{{element.customerCode}}" matTooltipPosition="below"
                            style="width: 20%;" class="mat-cell-non-boder-right-bottom">
                            <span class="fix-width">{{element.customerCode}}</span>
                        </mat-cell>
                    </ng-container>

                    <!-- Tên khách hàng -->
                    <ng-container matColumnDef="name">
                        <mat-header-cell *matHeaderCellDef style="width: 20%;" class="mat-cell-non-boder-right-bottom">
                            {{'enterprise_customer_management.table_headers.customer_name' | translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" matTooltip="{{element.name}}" matTooltipPosition="below"
                            style="width: 20%;" class="mat-cell-non-boder-right-bottom">
                            <span class="fix-width">{{element.name}}</span>
                        </mat-cell>
                    </ng-container>

                    <!-- MST/CMTND/Số giấy tờ -->
                    <ng-container matColumnDef="certificateNo">
                        <mat-header-cell *matHeaderCellDef style="max-width: 25%;"
                            class="mat-cell-non-boder-right-bottom">
                            {{'enterprise_customer_management.table_headers.taxCodeOrCertificateNo' | translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" style="max-width: 25%;"
                            class="mat-cell-non-boder-right-bottom number-cell-right"
                            matTooltip="{{element.customerType == personalId ? element.certificateNo : element.taxCode != null ? element.taxCode : element.certificateNo}}">
                            <span class="fix-width">{{element.customerType == personalId ? element.certificateNo :
                                element.taxCode
                                != null ? element.taxCode : element.certificateNo}}
                            </span>
                        </mat-cell>
                    </ng-container>

                    <!-- Email -->
                    <ng-container matColumnDef="email">
                        <mat-header-cell *matHeaderCellDef style="max-width: 20%;"
                            class="mat-cell-non-boder-right-bottom">
                            {{'enterprise_customer_management.table_headers.email' | translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" style="max-width: 20%;"
                            class="mat-cell-non-boder-right-bottom" matTooltip="{{element.email}}">
                            <span class="fix-width">{{element.email}}</span>
                        </mat-cell>
                    </ng-container>

                    <!-- Số điện thoại -->
                    <ng-container matColumnDef="phone">
                        <mat-header-cell *matHeaderCellDef style="max-width: 110px"
                            class="mat-cell-non-boder-right-bottom">
                            {{'enterprise_customer_management.table_headers.phone' | translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" style="max-width: 110px"
                            class="mat-cell-non-boder-right-bottom number-cell-center">
                            <span class="fix-width">{{element.phone}}</span>
                        </mat-cell>
                    </ng-container>

                    <!-- Loại khách hàng  -->
                    <ng-container matColumnDef="customerType">
                        <mat-header-cell *matHeaderCellDef style="max-width: 20%;">
                            {{'enterprise_customer_management.table_headers.customer_type' | translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" style="max-width: 20%;"
                            matTooltip="{{enterpriseTypeI18n.get(element.customerType) | translate}}">
                            <span class="fix-width">{{enterpriseTypeI18n.get(element.customerType) |
                                translate}}</span>
                        </mat-cell>
                    </ng-container>

                    <!-- Trạng thái đồng bộ Column -->
                    <ng-container matColumnDef="status_sync">
                        <mat-header-cell *matHeaderCellDef style="max-width: 160px"
                            class="special mat-header-cell-center">
                            <div>{{'headertable.sync_status' | translate}}</div>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" matTooltip="{{ element.syncStatusMessage }}"
                            style="max-width: 160px" (click)="$event.stopPropagation()" class="number-cell-center">
                            <span *ngIf="element.syncStatus === 'SYNCED'" class="title-status-sync synced">{{
                                'system_document_template.cbx_document_status.cbx_document_status_synced' |
                                translate
                                }}</span>
                            <span *ngIf="element.syncStatus === 'NOT_SYNCED'" class="title-status-sync not-synced">{{
                                'system_document_template.cbx_document_status.cbx_document_status_not_synced' |
                                translate }}</span>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                </mat-table>
            </div>
            <div class="py-4" *ngIf="error">
                <div class="card">
                    <p class="card-body text-danger" style="white-space: pre-wrap; padding-bottom: 0;">{{error}}</p>
                </div>
            </div>
            <!-- Pagination -->
            <app-pagination [(paginate)]="paginate" (pageChange)="onFilterCustomers($event.page, $event.pageSize)">
            </app-pagination>
            <!-- /Pagination -->
        </mat-expansion-panel>
    </mat-accordion>
</mat-dialog-content>
<div>
    <p class="mb-0 mt-3">
        <b><i>{{'synchronized.note' | translate}}</i></b>
        <i>{{'synchronized.synchronized_note' | translate}}</i>
    </p>
</div>
<!-- Huỷ bỏ & Đồng bộ & Đồng bộ tất cả  -->
<mat-dialog-actions class="mt-2" align="center">
    <button mat-stroked-button color="primary" class="mr-3 mb-1" (click)="onBtnCancelClick()" type="button" appTrackEvent="w.btn.danh_sach_kh.dong_bo.huy_bo">
        <mat-icon class="mr-0">cancel</mat-icon>
        {{'button.cancel' | translate}}
    </button>
    <button mat-raised-button type="button" color="primary" class="mr-3" (click)="synchronizeSelectedRecords()" appTrackEvent="w.btn.danh_sach_kh.dong_bot.dong_bo"
        [disabled]="this.dataSelected.size == 0">
        <mat-icon class="mr-0">refresh</mat-icon>
        {{'button.synchronized' | translate}}
    </button>
    <button mat-raised-button type="button" color="primary" (click)="synchronizeAll()" appTrackEvent="w.btn.danh_sach_kh.dong_bo.dongbo_all"
        [disabled]="this.dataSource.data.length == 0">
        <mat-icon class="mr-0">folder</mat-icon>
        {{'button.synchronized_all' | translate}}
    </button>
</mat-dialog-actions>
